import { useCuratedProjects, useCuratedProjectsTree } from 'stores/rq/projects';
import useStores from 'hooks/use-stores.hooks';
import { useCallback } from 'react';
import useSubscription from './use-subscription';

export const usePermissionChangesSubscriber = () => {
  const { userStore, authStore } = useStores();

  const { refetch: refetchFull } = useCuratedProjects({ enabled: authStore.isAuthenticated });
  const { refetch: refetchTree } = useCuratedProjectsTree({ enabled: authStore.isAuthenticated });

  const refetchProjects = useCallback(async () => {
    // need to refresh the token to get the new permissions
    await authStore.silentRenewSession();
    refetchFull?.();
    refetchTree?.();
  }, [authStore, refetchFull, refetchTree]);

  useSubscription({
    stream: 'permissionsChanged',
    key: userStore.profile?.sub,
    onEvent: refetchProjects,
    skipInitEvent: true
  });
};
